export type IconProps = {
  icon: string;
  width?: number;
  className?: string;
  alt?: string;
  title?: string;
};

export const Icon = ({
  className = "",
  icon,
  width,
  alt,
  title,
}: IconProps) => {
  return (
    <div className="icon-container">
      <span>
        <img className={className} width={width} src={icon} alt={alt} />
      </span>
      {title && <div className="icon-title">{title}</div>}
    </div>
  );
};
